import { useContext } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { apiPost } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

// Creates MonitoringExclusion rows for the given (analytic_ids × excludable)
// combination. Invalidates every monitoring-related query so cards the user
// was viewing reflect the new exclusion — both because matching transactions
// now drop out of the list, and because existing open matches are
// auto-Ignored by the backend service.
export default function useCreateMonitoringExclusions({ options = {} } = {}) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryClient = useQueryClient()

  return useMutation(
    async ({ sectionId, analyticIds, excludableType, excludableId, reason }) => {
      return apiPost({
        url: `municipalities/${municipality_id}/monitoring_exclusions`,
        token,
        objectName: 'monitoring_exclusion',
        params: {
          section_id: sectionId,
          analytic_ids: analyticIds,
          excludable_type: excludableType,
          excludable_id: excludableId,
          reason
        }
      })
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['analytics-monitoring-transactions'])
        queryClient.invalidateQueries(['analytics-monitoring'])
        queryClient.invalidateQueries(['monitoring-high-risk-transactions'])
        // The workflow index counts its backlog from the same reviews.
        queryClient.invalidateQueries(['monitoring-workflows'])
        queryClient.invalidateQueries(['monitoring-exclusions'])
        if (options.onSuccess) options.onSuccess(data, variables, context)
      }
    }
  )
}
